// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "public/94f20a0ac34737d7f132c980e4a1a1dc5b6213c9/" + chunkId + ".bundle.js";
};